module.exports = __webpack_public_path__ + "img/mv-digital-logo.b978aea7.svg";